import { Namespace } from '@repo/sdk/models/operations';

type UxdsVersionRollbackNamespaceConfig = {
  title: string;
  shortLabel: string;
  sdkNamespace: Namespace;
};

export const UXDS_VERSION_ROLLBACK_CONFIG = {
  process_view: { title: 'Process View', shortLabel: 'PV', sdkNamespace: Namespace.ProcessView },
  facility_map: { title: 'Facility Map', shortLabel: 'FM', sdkNamespace: Namespace.FacilityMap },
} as const satisfies Record<string, UxdsVersionRollbackNamespaceConfig>;

export type UxdsRollbackNamespace = keyof typeof UXDS_VERSION_ROLLBACK_CONFIG;

export const UXDS_VERSION_ROLLBACK_NAMESPACES = Object.keys(
  UXDS_VERSION_ROLLBACK_CONFIG
) as UxdsRollbackNamespace[];

export const UXDS_ROLLBACK_NAMESPACE_SET = new Set<string>(UXDS_VERSION_ROLLBACK_NAMESPACES);

/** Map SDK Namespace → rollback key; undefined if not registered */
export const toUxdsRollbackNamespace = (ns: Namespace): UxdsRollbackNamespace | undefined =>
  UXDS_VERSION_ROLLBACK_NAMESPACES.find(
    (key) => UXDS_VERSION_ROLLBACK_CONFIG[key].sdkNamespace === ns
  );

/** Map rollback key → SDK Namespace for API calls */
export const toSdkNamespace = (ns: UxdsRollbackNamespace): Namespace =>
  UXDS_VERSION_ROLLBACK_CONFIG[ns].sdkNamespace;

/** Legacy localStorage field names → config keys */
export const LEGACY_VERSION_FIELDS = {
  processViewVersion: 'process_view',
  facilityMapVersion: 'facility_map',
} as const satisfies Record<string, UxdsRollbackNamespace>;

/** Map SDK Namespace → rollback key for plumbed features; throws if not registered */
export const requireUxdsRollbackNamespace = (ns: Namespace): UxdsRollbackNamespace => {
  const key = toUxdsRollbackNamespace(ns);
  if (!key) {
    throw new Error(`Namespace "${ns}" is not registered for UXDS version rollback`);
  }
  return key;
};
